import { TrainingEvent } from "../shared/scenarioTypes";
export class ButtonClickedEvent extends TrainingEvent {
    static is(event) {
        return this.staticType === event.type;
    }
}
ButtonClickedEvent.staticType = "CONTROLLER_ACTION_CLICK";
export class TrainingObjectStateChangedEvent extends TrainingEvent {
    static is(event) {
        return this.staticType === event.type;
    }
}
TrainingObjectStateChangedEvent.staticType = "OBJECT_STATE_CHANGED";
export class TrainingObjectStateChangedInternalEvent extends TrainingEvent {
    constructor(scenarioObject, nextState, context) {
        super(`StateChanged-${scenarioObject.id}`, context, true);
        this.scenarioObject = scenarioObject;
        this.nextState = nextState;
    }
    static is(event) {
        return this.staticType === event.type;
    }
}
TrainingObjectStateChangedInternalEvent.staticType = "OBJECT_STATE_CHANGED";
export class StageChangedEvent extends TrainingEvent {
    static is(event) {
        return this.staticType === event.type;
    }
}
StageChangedEvent.staticType = "STAGE_CHANGED";
export class ObjectCollisionEvent extends TrainingEvent {
    static is(event) {
        return this.staticType === event.type;
    }
}
ObjectCollisionEvent.staticType = "OBJECT_COLLISION";
export class AttachmentChangedEvent extends TrainingEvent {
    static is(event) {
        return this.staticType === event.type;
    }
}
AttachmentChangedEvent.staticType = "ATTACHMENT_CHANGED";
export class VideoStateChangedEvent extends TrainingEvent {
    static is(event) {
        return this.staticType === event.type;
    }
}
VideoStateChangedEvent.staticType = "VIDEO_STATE_CHANGED";
export class WearableStateChangedEvent extends TrainingEvent {
    static is(event) {
        return this.staticType === event.type;
    }
}
WearableStateChangedEvent.staticType = "WEARABLE_STATE_CHANGED";
export class WearableStateChangeFailedEvent extends TrainingEvent {
    static is(event) {
        return this.staticType === event.type;
    }
}
WearableStateChangeFailedEvent.staticType = "WEARABLE_STATE_CHANGE_FAILED";
